import apiService from "../service";

export function fetchCategory() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/reg/category", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function fetchDistricts() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/pref/districts", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function fetchPosts() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/pref/posts", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function fetchPrefs() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/pref/fetchPreferences", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function downloadPrefs() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/pref/downloadPreferences", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function downloadAdminPrefs(reqNo) {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/admin/downloadPreferences", {params: { "regNo": reqNo }, headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}
export function fetchRegStatus() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.get("/reg/status", { headers: { "Authorization": "Bearer " + tokenDetails.token } });
    } catch (error) {
        //console.log(error)
    }
}

export function saveRegDetails(formData) {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.post("/reg/register", formData,
            {
                headers: {
                    "Authorization": "Bearer " + tokenDetails.token,
                    "Content-Type": "multipart/form-data"
                }
            });
    } catch (error) {
        //console.log(error)
    }
}
export function saveJoiningStatus(formData) {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.post("/reg/joiningStatus", { "hasJoined": formData },
            {
                headers: {
                    "Authorization": "Bearer " + tokenDetails.token
                }
            });
    } catch (error) {
        //console.log(error)
    }
}
export function saveDistPref(data, otp) {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.post("/pref/districts", { "preferenceDtos": data, "onetimepassword": otp },
            {
                headers: {
                    "Authorization": "Bearer " + tokenDetails.token,
                }
            });
    } catch (error) {
        //console.log(error)
    }
}
export function savePostPref(data, infodata, otp) {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.post("/pref/posts", { "preferenceDtos": data, "onetimepassword": otp, "optSplFacility": infodata.optSplFacility, "optSpecDeptPwd": infodata.optSpecDeptPwd },
            {
                headers: {
                    "Authorization": "Bearer " + tokenDetails.token,
                }
            });
    } catch (error) {
        //console.log(error)
    }
}
export function sentOtp() {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        return apiService.post("/notification/sendOtp", {},
            {
                headers: {
                    "Authorization": "Bearer " + tokenDetails.token,
                }
            });
    } catch (error) { }
}
export function downloadPostingOrder(regNo) {
    try {
        const tokenDetailsString = sessionStorage.getItem('userDetails');
        let tokenDetails = JSON.parse(tokenDetailsString);
        if (!regNo) {
            return apiService.get("/pref/posting-order",
                {
                    headers: {
                        "Authorization": "Bearer " + tokenDetails.token,
                    },
                    responseType: 'arraybuffer',
                });
        } else {
            return apiService.get("/admin/posting-order",
                {
                    params: { "regNo": regNo },
                    headers: {
                        "Authorization": "Bearer " + tokenDetails.token,
                    },
                    responseType: 'arraybuffer',
                });
        }

    } catch (error) { }
}